export default __webpack_public_path__ + "static/media/downwardTrend.a386e973.svg";